//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import Drawer from '@/components/drawer';
import _ from 'lodash';
import jsonEdit from '@/components/jsonEdit/index.vue';
export default {
  name: 'SandBoxTemplateCreate',
  components: { Drawer, jsonEdit },
  props: {
    row: { type: Object, default: () => {} },
    visible: {
      type: Boolean,
      default: false,
    },
    operateType: {
      type: String,
      default: 'add',
    },
  },
  data() {
    return {
      form: {
        id: '',
        name: '',
        desensitize_rule: '{}',
        sync_objects: [],
      },
      syncObjectOptions: [],
      rules: {
        name: [{ required: true, message: '请输入名称', trigger: 'submit' }],
      },
      checked: false,
      showJson: false,
    };
  },
  watch: {
    visible() {
      if (this.visible) {
        this.getAllSandboxTemplate();
        // this.operateType
        console.log('%c Line:98 🌽 this.operateType', 'color:#465975', this.operateType);
        if (this.operateType === 'add') {
          this.form = {
            id: '',
            name: '',
            desensitize_rule: '{}',
            sync_objects: [],
          };
          console.log('%c Line:130 🍆 this.form', 'color:#4fff4B', this.form);
        } else {
          this.form = _.cloneDeep(this.row);
        }
        this.$refs.form.resetFields();
      }
    },
  },

  methods: {
    selectAll() {
      this.form.sync_objects = [];
      if (this.checked) {
        this.syncObjectOptions.forEach((item) => {
          this.form.sync_objects.push(item.name);
        });
      } else {
        this.form.sync_objects = [];
      }
    },
    changeSelect(val) {
      if (val.length === this.syncObjectOptions.length) {
        this.checked = true;
      } else {
        this.checked = false;
      }
    },
    getAllSandboxTemplate() {
      this.$request({
        url: this.$api.metaGetObjectList,
        data: {
          limit: 99999,
          offset: 0,
        },
      }).then((res) => {
        // res
        console.log('%c Line:142 🥪 res', 'color:#6ec1c2', res);
        this.syncObjectOptions = res.objects;
      });
    },
    cancel() {
      this.$confirm('确认退出吗?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      }).then(() => {
        this.close();
      });
    }, 
    close() {
      this.$emit('close');
    },
    openJsonEdit() {
      this.showJson = true;
    },
    saveJson(json) {
      this.form.desensitize_rule = JSON.stringify(JSON.parse(json));
      this.$nextTick(() => {
        this.showJson = false;
      });
    },
    createSandBoxTemplate() {
      this.$refs.form.validate((valid) => {
        // valid
        console.log('%c Line:77 🥤 valid', 'color:#ffdd4d', valid);
        if (valid) {
          // this.form
          console.log('%c Line:122 🥝 this.form', 'color:#ed9ec7', this.form);
          if (this.operateType === 'add') {
            const params = {
              name: this.form.name,
              sync_objects: this.form.sync_objects,
              desensitize_rule: this.form.desensitize_rule,
            };
            this.$request({
              url: this.$api.createSandboxTemplate,
              data: params,
            }).then((res) => {
              console.log('%c Line:130 🍫 res', 'color:#33a5ff', res);
              this.$emit('refresh');
              this.close();
            });
          } else {
            const params = {
              id: Number(this.row.id),
              name: this.form.name,
              sync_objects: this.form.sync_objects,
              desensitize_rule: this.form.desensitize_rule,
            };
            // params
            console.log('%c Line:209 🍖 params', 'color:#ed9ec7', params);
            this.$request({
              url: this.$api.updateSandboxTemplate,
              data: params,
            }).then((res) => {
              console.log('%c Line:130 🍫 res', 'color:#33a5ff', res);
              this.$emit('refresh');
              this.close();
            });
          }
        } else {
          this.$message.warning('请填写必填项');
        }
      });
    },
  },
};
